import React, { useState } from 'react';

function FileUpload() {
    const [preview, setPreview] = useState(null);
    const [fileName, setFileName] = useState('');
    const [fileType, setFileType] = useState('');

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            setFileName(file.name);
            setFileType(file.type);

            if (file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreview(reader.result);
                };
                reader.readAsDataURL(file);
            } else {
                setPreview(null); // No preview for non-images
            }
        }
    };

    return (
        <div className="w-full flex flex-col items-center justify-center">
            <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
            >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400" fill="none" viewBox="0 0 20 16">
                        <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5A5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                    </svg>
                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                        <span className="font-semibold">Click to upload</span> or drag and drop
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                        PDF,PNG, JPG,  (MAX. 800x400px for images)
                    </p>
                </div>
                <input
                    id="dropzone-file"
                    type="file"
                    accept=".png,.jpg,.jpeg,.gif,.svg,.pdf"
                    className="hidden"
                    onChange={handleFileChange}
                />
            </label>

            {fileType === 'application/pdf' && (
                <div className="mt-4 text-sm text-gray-700 dark:text-white">
                    <span className="font-medium">Uploaded PDF:</span> {fileName}
                </div>
            )}

            {fileType.startsWith('image/') && preview && (
                <div className="mt-4">
                    <img src={preview} alt="Preview" className="max-h-60 rounded-md border" />
                </div>
            )}
        </div>
    );
}

export default FileUpload;
